var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"large":"","block":"","color":"deep-orange darken-3 white--text"}},[_vm._v("\n  Se connecter avec Example\n")])}
var staticRenderFns = []

export { render, staticRenderFns }